import { useState } from 'react'
import PropTypes from 'prop-types'

import {
  FormControlLabel,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from '@mui/material'

import useTranslations from '../../../../i18n/useTranslations'
import Combo from '../../../../ui/components/combo'
import Select from '../../../../ui/components/select'
import { getFieldProps } from '../../../../common/formProps'
import useStyles from '../../../../ui/modules/shipmentsSearch/styles'

const PostalCode = ({ values, fieldErrors, touched, handleChange }) => {
  const classes = useStyles()
  const t = useTranslations()

  const [showRange, setShowRange] = useState(!!values.postalCodeTo ?? false)

  const handleChangeSwitch = () => {
    if (showRange)
      handleChange({
        target: { name: 'postalCodeTo', value: '' },
      })
    setShowRange(!showRange)
  }

  return (
    <div>
      <Combo className={classes.comboPostalCode}>
        <Select
          labelId="postalCodeSource"
          defaultValue="origin"
          id="postalCodeSource"
          name="postalCodeSource"
          label={
            <Typography variant="h4bold">{t('noun:postal-code')}</Typography>
          }
          {...getFieldProps(
            'postalCodeSource',
            values,
            fieldErrors,
            touched,
            t,
          )}
          className="input-small"
          onChange={handleChange}
        >
          <MenuItem key="origin" value="origin">
            {t('noun:from-source')}
          </MenuItem>
          <MenuItem key="destin" value="destin">
            {t('noun:from-destin')}
          </MenuItem>
        </Select>
        {showRange ? (
          <>
            <TextField
              name="postalCodeFrom"
              {...getFieldProps(
                'postalCodeFrom',
                values,
                fieldErrors,
                touched,
                t,
              )}
              placeholder="00000"
              className="input-micro "
              onChange={handleChange}
            />

            <TextField
              name="postalCodeTo"
              {...getFieldProps(
                'postalCodeTo',
                values,
                fieldErrors,
                touched,
                t,
              )}
              placeholder="00000"
              className="input-micro"
              onChange={handleChange}
            />
          </>
        ) : values.postalCodeSource === 'origin' ? (
          <TextField
            name="originPostalCode"
            {...getFieldProps(
              'originPostalCode',
              values,
              fieldErrors,
              touched,
              t,
            )}
            placeholder="00000"
            className="input-micro "
            onChange={handleChange}
          />
        ) : (
          <TextField
            name="destinPostalCode"
            {...getFieldProps(
              'destinPostalCode',
              values,
              fieldErrors,
              touched,
              t,
            )}
            placeholder="00000"
            className="input-micro "
            onChange={handleChange}
          />
        )}
      </Combo>
      <FormControlLabel
        control={
          <Switch
            checked={showRange}
            onChange={handleChangeSwitch}
            name="checkedB"
            color="primary"
          />
        }
        label={t('noun:want-search-by-range')}
        sx={{ mb: 3.5 }}
      />
    </div>
  )
}
PostalCode.propTypes = {
  values: PropTypes.shape({
    postalCodeSource: PropTypes.string.isRequired,
    postalCodeFrom: PropTypes.string.isRequired,
    postalCodeTo: PropTypes.string.isRequired,
    originPostalCode: PropTypes.string.isRequired,
    destinPostalCode: PropTypes.string.isRequired,
  }),
  fieldErrors: PropTypes.shape({
    postalCodeSource: PropTypes.string.isRequired,
    postalCodeFrom: PropTypes.string.isRequired,
    postalCodeTo: PropTypes.string.isRequired,
    originPostalCode: PropTypes.string.isRequired,
    destinPostalCode: PropTypes.string.isRequired,
  }),
  touched: PropTypes.shape({
    postalCodeSource: PropTypes.string,
    postalCodeFrom: PropTypes.string,
    postalCodeTo: PropTypes.string,
    originPostalCode: PropTypes.string,
    destinPostalCode: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
}

export default PostalCode
